import { render, staticRenderFns } from "./heroHomepageDebug.vue?vue&type=template&id=ec59c700&"
import script from "./heroHomepageDebug.vue?vue&type=script&lang=js&"
export * from "./heroHomepageDebug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec59c700')) {
      api.createRecord('ec59c700', component.options)
    } else {
      api.reload('ec59c700', component.options)
    }
    module.hot.accept("./heroHomepageDebug.vue?vue&type=template&id=ec59c700&", function () {
      api.rerender('ec59c700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/heroHomepage/heroHomepageDebug.vue"
export default component.exports